<template lang="pug">
  a.preview-image(
    href="#"
    @click.prevent.stop
    v-touch:tap="($event) => $emit('maximize', { event: $event, media })"
    @mouseover.prevent.stop="focus"
    @mouseleave.prevent.stop="leave"
  )
    .observer
      lazy-component(@show="show")
        img(:src="image.src")
    figure.image(
      :style="style"
    )
      img(
        :src="image.src"
        :class="{ loaded }"
      )
</template>

<script>
// import { get } from '@/helpers'
import { mapMutations, mapGetters } from 'vuex';

export default {
    name: 'PreviewImage',
    data: () => ({
        loaded: false
    }),
    props: {
        media: {
            type: Object,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        width: {
            type: Number,
            default: 246
        },
        aspectRatio: {
            type: Number
        }
    },
    computed: {
        height() {
            let height;
            if (this.aspectRatio) height = this.width / this.aspectRatio;
            else height = this.width / (this.media.image.width / this.media.image.height);
            return height;
        },
        style() {
            return {
                width: `${this.width}px`,
                height: `${this.height}px`
                // 'background-image': `url(${this.image.blurry})`
            };
        },
        image() {
            let image = this.media.image;
            if (!image) return false;
            const source = image.source;

            let root = '';
            const endpoint = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}`;
            if (process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE;
            const base = endpoint + root + 'images/';

            let format = '';
            if (this.webpSupport) format = '&format=webp';

            return {
                src: `${base}${image.id}/${source.name}?fit&w=${this.width}&h=${this.height}${format}`,
                error: `${base}${image.id}/${source.name}?fit&w=${this.width}&h=${this.height}&preview=greyscale`,
                blurry: `${base}${image.id}/${source.name}?fit&w=${this.width}&h=${this.height}&preview=blur`
            };
        },
        ...mapGetters({
            webpSupport: 'webpSupport'
        })
    },
    methods: {
        show() {
            this.loaded = true;
            // setTimeout(() => this.loaded = true, 600)
        },
        focus() {
            this.setFocusedMedia({ product: this.product, media: this.media });
        },
        leave() {
            this.removeFocusedMedia();
        },
        ...mapMutations({
            setFocusedMedia: 'shop/setFocusedMedia',
            removeFocusedMedia: 'shop/removeFocusedMedia'
        })
    }
};
</script>

<style lang="sass" scoped>
.observer
  display: absolute
  width: 0
  height: 0
  left: -300vw
.image
  @apply bg-gray-200
  overflow: hidden
  border: 1px solid #d4d4d4
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  background-color: #fff
  img
    opacity: 0
    height: 100%
    width: 100%
    object-fit: contain
    transition: opacity .3s ease
    &.loaded
      opacity: 1
</style>
